<template>

    <div>
        <slider />
        <!--<video width="320" height="240" controls>
            <source src="https://www.dropbox.com/s/pqoi3asxrfdzv3s/P.%20Pedersen%20%26%20S%C3%B8n%20ApS%20Cover%20Video%201.2.mov?raw=1" type="video/mp4">
            Your browser does not support the video tag.
        </video>-->
        <index-boxes />
        <!--<promo />
        <div class="container pd-50">
            <certificates />
            <documents />
        </div>-->

        <div style="background:#141e36;color:#fff;">
            <div class="container pd-50">
                <h1 style="font-size:30px;color:#fff;margin-bottom:30px;">
                    Transportfirma
                </h1>
                <h2 style="font-size:20px;color:#fff;margin-bottom:30px;">
                    Transportfirma, Fragt og Vognmand P. Pedersen & Søn Ærø
                </h2>
                <p>
                    Vi er en solid og velkonsolideret transportvirksomhed med flere årtier på bagsmækken, som dagligt leverer en bred vifte af services til vores kunder. Hos os er der mulighed for at få transporteret mange forskellige slags gods. Vi kan håndtere en eller flere afhentninger af alt fra den mindste kolli op til 38 tons pr. gang.
                </p>
                <p>
                    Vi kan med stolthed sige, at transport er en del af vores DNA. Vi er stolte af vores virksomhed og vores omhyggelige engagerede medarbejdere. Vi behandler godset som var det firmaets eget. Vi yder vores bedste hver dag i bestræbelserne på at give den bedst mulige service overfor vores kunder.
                </p>
                <div style="margin:30px 0;">
                    <contact-cta />
                </div>
                <p>
                    Fragt og Vognmandsfirma P. Pedersen & Søn Ærø har altid haft en klar holdning til kvalitet, professionel håndtering, høj service og rettidig distribution. 
                </p>
                <p>
                    Det er vigtigt for os at du har tillid til os, hvilket vi vægter højt i vores transportfirma. Vores medarbejdere er vores største styrke. Omgangstonen er uformel og vi har stor tillid til hinanden. Alle vores medarbejdere er motiverede og ansvarsbevidste, og de har en positiv tilgang til vores samarbejde med vores kunder. 
                </p>
                <p>
                    Vi fokuserer på punktlighed hvilket betyder, at du får dine leverancer til tiden. Vi har professionelle chauffører som er uddannet til at håndtere alle typer af gods.
                </p>
                <p>
                    Du kan stole på, at transportere vi dine pakker eller gods – så bliver det ansvarligt behandlet og kommer sikkert frem, da du altid får en kompetent chauffør til jobbet.
                </p>
            </div>
        </div>

        <div class="container pd-50">
            <h3 style="font-size:20px;">
                Transportfirma i Danmark
            </h3>
            <p>
                Fragt og Vognmandsfirma P. Pedersen & Søn Ærø er et transportfirma som gennem samarbejde med anerkendte transportører, kan betjene kunder i hele landet. Alle vores kunder har forskellige behov for transport, og vi gør altid vores bedste for at imødekomme disse ønsker og behov. Vi har den nødvendige viden og erfaring til at tilbyde dig individuelle ydelser, og til at skræddersy løsninger til både private- og erhvervskunder.
            </p>

            <h3 style="margin-top:30px;font-size:20px;">
                Kurerkørsel af forskellige slags
            </h3>
            <p>
                Kurerkørsel er en transportmulighed, for de af vores kunder som skal have transporteret noget her og nu og gerne til en specifik adresse.
            </p>
            <p>
                Fragt og Vognmandsfirma P. Pedersen & Søn Ærø har store erfaringer med kurerkørsel af hasteleveringer til hele landet.  Vi er i tæt dialog med vores kunder, hvor vi forventningsafstemmer og snakker om dine individuelle behov. Vi afdækker gennem en indledende samtale, hvilken opgave og hvilken vare I måtte have behov for at få kurerkørsel af.
            </p>
            <p>
                Samtalen vil bl.a. indeholde:
                <ul>
                    <li>Er det en hastesag?</li>
                    <li>Hvad skal leveres?</li>
                    <li>Hvor lang er ruten?</li>
                </ul>
            </p>
            <p>
                Vi ønsker at afdække disse behov bedst muligt med vores fleksible og professionelle løsninger. Vi er også af den overbevisning, at du som kunde hos os ikke skal betale for mere end højst nødvendigt, og fordi vi ønsker at være konkurrencedygtige.
            </p>
            <div style="display:flex;margin:30px 0;">
                <div class="btn-holder alt">
                    <a href="/fragtfirma" class="btn-primary text-center text-uppercase active md-round" style="margin-right:15px;">
                        Læs mere
                    </a>
                </div>
                <contact-cta />
            </div>
            <p>
                Hos Fragt og Vognmandsfirma P. Pedersen & Søn Ærø har du mulighed for at få transporteret mange forskellige slags gods.
            </p>
        </div>

        <div style="background:#edf2f7;padding:30px 0;border-top:1px solid #ddd;border-bottom:1px solid #ddd;">
            <div class="container pd-50">
                <div class="box">
                    <div style="font-weight:bold;font-size:20px;margin-bottom:15px;">
                        Stykgods / Partigods
                    </div>
                    <p>
                        Når du vælger Fragt og Vognmandsfirma P. Pedersen & Søn Ærø til distribution af dit stykgods i Danmark, vælger du et vognmandsfirma, som ønsker at være den forlængede arm ud til dig. Det betyder du med ro kan stole på, at vi transporterer dine varer sikkert, og at varerne når frem i tide i korrekt tilstand.
                    </p>
                    <p>
                        Stykgods eller partigods er en forsendelse som er over 20 kg. Vi har mulighed for at sende både enkeltvis, små kolli, eller større partier. Som ekstra service har vi også en medbringertruck til levering af dit gods, hvor vores fragtbiler ikke når ind.
                    </p>
                    <p>
                        Fragt og Vognmandsfirma P. Pedersen & Søn Ærø sender og henter dagligt småpakker og stykgods fra fastlandet til Ærø i tæt samarbejde med anerkendte transportører. Forsendelser afhentet hos en virksomhed eller indleveret på vores lager i Odense inden kl. 09:00 leveres samme dag hos modtager på Ærø. Fragt og Vognmandsfirma P. Pedersen & Søn kan betjene kunder i hele landet.
                    </p>
                    <div class="btn-holder alt">
                        <a href="/transportloesninger/stykgods" class="btn-primary text-center text-uppercase active md-round" style="margin-right:15px;">
                            Læs mere
                        </a>
                    </div>
                </div>
                <div class="box" style="margin-top:30px;">
                    <div style="font-weight:bold;font-size:20px;margin-bottom:15px;">
                        Bulk / Walking floor
                    </div>
                    <p>
                        Bulkgods betegner gods som transporteres u-pakket, dvs. løst (f.eks. forskellige kornarter, træpiller, flis etc.).
                    </p>
                    <p>
                        Fragt og Vognmandsfirma P. Pedersen & Søn Ærø transporterer løst gods med Walking floor trailere, som via hydraulik kan flytte lameller som ligger i bunden af traileren frem og tilbage. På den måde læsses u-pakket løst gods af i stedet for at tippe traileren. 
                    </p>
                    <p>
                        Vi mener det er den ideelle trailer til løst volume gods, da det er nemt og hurtigt at læsse godset af ved med det bevægelige gulv, og vi benytter Walking floor trailerne til flere formål.
                    </p>
                    <p>
                        Fragt og Vognmandsfirma P. Pedersen & Søn Ærø transporterer ikke alene løse foderstoffer, træflis og forskellige kornarter, men også træpiller og pallegods. Den ene Walking floor trailer kan åbnes i siden, hvilket gør det er muligt at laste og losse gods vandret i traileren. 
                    </p>
                    <div class="btn-holder alt">
                        <a href="/transportloesninger/bulk" class="btn-primary text-center text-uppercase active md-round" style="margin-right:15px;">
                            Læs mere
                        </a>
                    </div>
                </div>
                <div class="box" style="margin-top:30px;">
                    <div style="font-weight:bold;font-size:20px;margin-bottom:15px;">
                        Køl / frys
                    </div>
                    <p>
                        Transport af fryse- og kølevarer er en af Fragt og Vognmandsfirma P. Pedersen & Søn Ærø stærke kompetencer. Vi har vi nogle af landets mest moderne kølevogne, som alle opfylder markedets krav om køletransport til at fragte vores temperaturfølsomme gods. Hygiejnen er i højsæde, og vi sikre naturligvis at kølekæden ikke brydes under transporten. Det betyder du kan være sikker på at modtage dine varer med en garanteret friskhed. 
                    </p>
                    <p>
                        Dagligt transporterer Fragt og Vognmandsfirma P. Pedersen & Søn Ærø temperaturfølsomme varer til butikker, cateringfirmaer, hoteller og restauranter til hele Ærø.
                    </p>
                    <div class="btn-holder alt">
                        <a href="/transportloesninger/koel-frys" class="btn-primary text-center text-uppercase active md-round" style="margin-right:15px;">
                            Læs mere
                        </a>
                    </div>
                </div>
                <div class="box" style="margin-top:30px;">
                    <div style="font-weight:bold;font-size:20px;margin-bottom:15px;">
                        Farligt gods / fyrværkeri (ADR)
                    </div>
                    <p>
                        Få transporteret dit farlige gods (ADR) hos Fragt og Vognmandsfirma P. Pedersen & Søn Ærø af professionelt uddannede og godkendte chauffører. 
                    </p>
                    <p>
                        Vi sørger for at håndtere og transportere dit farlige gods (ADR) sikkert - uanset om der er tale om ilt, gas, cellulosefortynder, maling, fyrværkeri, krudt og kugler etc.
                    </p>
                    <p>
                        Hos os kan du altid trygt regne med at det farlig gods (ADR) er forsvarligt pakket og surret, og kommer sikkert frem fra afsender til modtager.
                    </p>
                    <div class="btn-holder alt">
                        <a href="/transportloesninger/farligt-gods" class="btn-primary text-center text-uppercase active md-round" style="margin-right:15px;">
                            Læs mere
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div id="miljo" class="container pd-50">
            <div class="row">

                <div class="col-lg-6 col-md-6 col-sm-12">
                    <h4 style="font-size:24px;">
                        Fragt og Vognmandsfirma P. Pedersen & Søn Ærø har fokus på miljø og sikkerhedskrav
                    </h4>
                    <p>
                        Fragt og Vognmandsfirma P. Pedersen & Søn Ærø ved at vores virksomhed er med til at påvirke miljøet og det samfund vi er en del af bl.a. gennem CO2udslip. Derfor udskifter vi løbende vores biler så vi overholder gældende EU-normer. 
                    </p>
                    <p>
                        <b>Fragt og Vognmandsfirma P. Pedersen & Søn Ærø:</b>
                        
                        <div class="flex-wrapper">
                            <div class="icon">
                                <i class="fal fa-boxes fa-fw" />
                            </div>
                            <div class="text">
                                Tager ansvar for kundernes varer
                            </div>
                        </div>

                        <div class="flex-wrapper">
                            <div class="icon">
                                <i class="fal fa-tree-alt fa-fw" />
                            </div>
                            <div class="text">
                                Tager ansvar for miljøet
                            </div>
                        </div>

                        <div class="flex-wrapper">
                            <div class="icon">
                                <i class="fal fa-file-alt fa-fw" />
                            </div>
                            <div class="text">
                                Har chauffører, som altid er opdaterede med gældende kurser og uddannelser med fokus på at nedbringe arbejdsulykker
                            </div>
                        </div>

                        <div class="flex-wrapper">
                            <div class="icon">
                                <i class="fal fa-thumbs-up fa-fw" />
                            </div>
                            <div class="text">
                                Har chauffører, som viser respekt i lokalsamfundet og agere så de altid er til mindst muligt gene på vejene
                            </div>
                        </div>

                        <div class="flex-wrapper">
                            <div class="icon">
                                <i class="fal fa-file-certificate fa-fw" />
                            </div>
                            <div class="text">
                                Har altid opdaterede tilladelser / certificeringer inden for fødevaresikkerhed og fødevarehygiejne, farligt gods mm. i henhold til gældende love og regler
                            </div>
                        </div>
                        
                        <!--<ul>
                            <li>
                                tager ansvar for kundernes varer.
                            </li>
                            <li>
                                tager ansvar for miljøet.
                            </li>
                            <li>
                                chaufførerne er ALTID opdaterede med gældende kurser og uddannelser.
                            </li>
                            <li>
                                har altid opdaterede tilladelser/certificering inden for fødevaresikkerhed og fødevarehygiejne, farligt gods mm. i henhold til gældende love og regler.
                            </li>
                        </ul>-->
                    </p>
                    <div style="margin-top:30px;">
                        <contact-cta />
                    </div>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-12">
                    <img src="/static/images/snow.jpg" style="width:100%;border-radius:4px;" />
                </div>

            </div>
        </div>

        <div class="container pd-50">
            <h4 style="font-size:20px;">
                Lad vores Fragt og Vognmandsfirma transportere dit gods
            </h4>
            <p>
                Hvis du vægter pålidelighed og professionalisme højt, så er vores Fragt og Vognmandsfirma P. Pedersen & Søn Ærø det helt rette valg for dig. Du får altid erfarne chauffører, der kender deres ansvar og opgaver. Vi har gode priser, og kan tilbyde dig et uforpligtende tilbud.
            </p>
            <p>
                Skal vores Fragt og Vognmandsfirma P. Pedersen & Søn Ærø transportere dit gods sikkert frem? Vi er aldrig længere end et opkald væk.
            </p>
            <p>
                Kontakt os allerede i dag ved at ringe på telefon 40 43 60 78 eller ved at sende en e-mail til karsten@p-pedersen.dk så vender vi hurtigst muligt tilbage.
            </p>
        </div>

    </div>

</template>
<script>
    import Slider from '../../components/elements/slider'
    import IndexBoxes from '../../components/index/index-boxes'
    import Promo from '../../components/index/promo'
    import Certificates from '../../components/index/certificates'
    import Documents from '../../components/index/documents'
    export default {
        components: {
            'slider': Slider,
            'index-boxes': IndexBoxes,
            'promo': Promo,
            'certificates': Certificates,
            'documents': Documents
        }
    }
</script>



// WEBPACK FOOTER //
// index.vue?fe6df81a